export const JSONHeaders = {
	"Content-Type": "application/json",
	Accept: "application/json"
}
